import { render, staticRenderFns } from "./SecureRedirect.vue?vue&type=template&id=a9389ee4&"
import script from "./SecureRedirect.vue?vue&type=script&lang=ts&"
export * from "./SecureRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports